import OBase from './OBase';

import * as Geometry from '../geometry';

export default class GateMajority extends OBase {
  update () {
    var aValTree = this.getBoolInput('A');
    var bValTree = this.getBoolInput('B');
    var cValTree = this.getBoolInput('C');

    var rOutput = this.getGenericObjectOutput('Result');

    var dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(aValTree, bValTree, cValTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        var aVal = outDataTrees[0].branches[i][j];
        var bVal = outDataTrees[1].branches[i][j];
        var cVal = outDataTrees[2].branches[i][j];

        let aValI = aVal ? 1 : 0;
        let bValI = bVal ? 1 : 0;
        let cValI = cVal ? 1 : 0;
        let total = aValI + bValI + cValI;
        let val = false;
        if (total >= 2) {
          val = true;
        }

        outTree.add(val, outDataTrees[0].paths[i]);
      }
    }

    rOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/GateMajority.js